<template>
    <div>
        <selected-filters :selected="filterValues" :translatable="[]" @delete-filter="clearFilter" />
        <price-filter
            v-if="filters.price"
            :filter-values="filterValues"
            :label="$t('price')"
            :filters="filters"
            :currency="currency"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.supplierName && filters.supplierName.length > 1 && isTO1"
            :filter-values="filterValues"
            :filters="filters"
            filter="supplierName"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            :filters="filters"
            filter="name"
            :placeholder="$t('cruises.filter_cruise_name')"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.availability && filters.availability.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="availability"
            :translate-labels="true"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.mealTypeName && filters.mealTypeName.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="mealTypeName"
            :translate-labels="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.cabinType && filters.cabinType.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="cabinType"
            :translate-labels="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.cancellationPolicy && filters.cancellationPolicy.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="cancellationPolicy"
            @change="change($event)"
        />
        <range-filter
            v-if="filters.duration && filters.duration[1] !== Infinity && filters.duration[1]"
            :filters="filters"
            filter="duration"
            :pluralization="true"
            :label="$t('duration')"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.dates && filters.dates.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="dates"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.cruiseLine && filters.cruiseLine.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="cruiseLine"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.shipName && filters.shipName.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="shipName"
            @change="change($event)"
        />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import CheckboxFilter from '~/components/search/filters/CheckboxFilter.vue'
    import FilteredMobileButton from '~/components/snippets/FilteredMobileButton.vue'
    import NameFilter from '~/components/filters/NameFilter.vue'
    import SelectedFilters from '~/components/snippets/SeletedFilters.vue'
    import PriceFilter from '~src/components/search/filters/priceFilter.src'
    import {FiltersBase} from '@/components/search/FiltersBase.vue'
    import RangeFilter from '@/components/search/filters/RangeFilter.vue'

    @Component({
        components: {
            RangeFilter,
            PriceFilter,
            CheckboxFilter,
            FilteredMobileButton,
            NameFilter,
            SelectedFilters,
        },
    })
    export class CruisesFilters extends FiltersBase {}

    export default CruisesFilters
</script>
